export default __webpack_public_path__ + "static/media/java-2d-template-icon.25019324.png";